import { useNotification } from '@revenuewell/front-end-bundle';
import { FC, useEffect, useState } from 'react';
import { useInsuranceApi } from '../../../../hooks/use-insurance-api';
import { VerificationSummary } from '../../../../services/insurance/types/verification-summary';
import { EventIvShowApptRequestVerificationDialog } from '../../../../types/event-bus';
import InaccurateDataDialog from './innacurate-data/inaccurate-data-dialog';
import InsuranceInactiveDialog from './insurance-inactive/insurance-inactive-dialog';
import InsuranceTermedDialog from './insurance-termed/insurance-termed-dialog';
import InsuranceVerifiedDialog from './insurance-verified/insurance-verified-dialog';
import ManuallyVerifiedDialog from './manually-verified/manually-verified-dialog';
import NotRegisteredWithPayerDialog from './not-registered-with-payer/not-registered-with-payer';
import NpiInvalidDialog from './npi-invalid/npi-invalid-dialog';
import NpiMissingDialog from './npi-missing/npi-missing-dialog';
import PatientDataMissingDialog from './patient-data-missing/patient-data-missing-dialog';
import PayerNotSetupDialog from './payer-not-setup/payer-not-setup-dialog';
import PayerUnableToRespondDialog from './payer-unable-to-respond/payer-unable-to-respond-dialog';
import ProviderRelationshipInvalidDialog from './provider-relationship-invalid/provider-relationship-invalid-dialog';
import RequestDataInvalidDialog from './request-data-invalid/request-data-invalid-dialog';
import SelfPayDialog from './self-pay/self-pay-dialog';
import UnknownPatientStatusDialog from './unknown-patient-status/unknown-patient-status-dialog';
import VerificationInProcessDialog from './verification-in-process/verification-in-process-dialog';

export interface ApptRequestIvDialogSelectorProps {
  opened: boolean;
  insuranceEvent: EventIvShowApptRequestVerificationDialog;
  onClose: () => void;
}

export const ApptRequestIvDialogSelector: FC<ApptRequestIvDialogSelectorProps> = (props) => {
  const { opened, insuranceEvent, onClose } = props;
  const { showError } = useNotification();
  const { getAppointmentRequestVerificationSummaries } = useInsuranceApi();
  const [ivSummary, setIvSummary] = useState<VerificationSummary>();

  useEffect(() => {
    if (insuranceEvent) {
      (async () => {
        const eventData = insuranceEvent.data;
        const sum = await getAppointmentRequestVerificationSummaries([eventData.apptRequestId], eventData.locationId);

        if (sum.length > 0) {
          setIvSummary(sum[0].verificationSummary);
        } else {
          showError('Unable to load insurance verification.');
        }
      })();
    }
  }, [insuranceEvent]);

  const dialogProps = {
    opened,
    onClose,
    ivSummary,
    appointmentRequestId: insuranceEvent.data.apptRequestId,
    locationId: insuranceEvent.data.locationId
  };

  if (!ivSummary) return;

  switch (ivSummary.ivSummaryStatus) {
    case 'InsuranceInProcess':
      return <VerificationInProcessDialog {...dialogProps} />;
    case 'InsuranceVerified':
      return <InsuranceVerifiedDialog {...dialogProps} />;
    case 'SelfPay':
      return <SelfPayDialog {...dialogProps} />;
    case 'ManuallyVerified':
      return <ManuallyVerifiedDialog {...dialogProps} />;
    case 'InsuranceInactive':
      return <InsuranceInactiveDialog {...dialogProps} />;
    case 'InsuranceTermed':
      return <InsuranceTermedDialog {...dialogProps} />;
    case 'PatientDataMissing':
      return <PatientDataMissingDialog {...dialogProps} />;
    case 'RequestDataInvalid':
      return <RequestDataInvalidDialog {...dialogProps} />;
    case 'PayerNotSetup':
      return <PayerNotSetupDialog {...dialogProps} />;
    case 'NpiInvalid':
      return <NpiInvalidDialog {...dialogProps} />;
    case 'NpiMissing':
      return <NpiMissingDialog {...dialogProps} />;
    case 'ProviderRelationshipInvalid':
      return <ProviderRelationshipInvalidDialog {...dialogProps} />;
    case 'NotRegisteredWithPayer':
      return <NotRegisteredWithPayerDialog {...dialogProps} />;
    case 'PayerUnableToRespond':
      return <PayerUnableToRespondDialog {...dialogProps} />;
    case 'InaccurateData':
      return <InaccurateDataDialog {...dialogProps} />;
    case 'UnknownPatient':
      return <UnknownPatientStatusDialog {...dialogProps} />;
    default:
      return null;
  }
};
